module.exports = __webpack_public_path__ + "img/JPME_80X30.f451a67d.png";